import { cn } from '@/shared/utils/cn';

type FieldErrorProps = {
  id?: string;
  message?: string;
  className?: string;
};

export function FieldError({ id, message, className }: FieldErrorProps) {
  if (!message) return null;

  return (
    <p
      id={id}
      role="alert"
      aria-live="polite"
      aria-atomic="true"
      className={cn(
        'text-xs font-medium text-adipa-error',
        className,
      )}
    >
      {message}
    </p>
  );
}
